"use client"

import Image from "next/image"
import { useRouter } from "next/navigation"

export default function NotFound() {
    const router = useRouter()

    return (

        <div className="w-full h-screen flex items-center justify-center bg-gradient-to-br from-white to-[#d4d4d4] flex-col">

            <div className='w-[100px] h-[100px] '>

                <Image
                    src='/assets/images/icon2.png'
                    alt=""
                    width={200}
                    height={200}
                    className='rounded-[15px] shadow-lg shadow-gray-500'
                />

                <div
                    className="w-[27.5px] h-[27.5px] bg-yellow-500 rounded-full relative bottom-[111px] left-[86px] flex items-center justify-center"
                >

                    <h1 className="font-tpBold text-white text-[20px] relative left-[1px]">
                        ?
                    </h1>

                </div>

            </div>

            <h1 className="font-tpBold text-[20px] pt-[30px] pb-[10px] relative left-3">

                Couldn't find the page ... 
                
            </h1>
                

            <button 
                className="w-[160px] h-[40px] bg-white rounded-full shadow-gray-500 shadow-md font-tpThin text-[16px]"
                onClick={() =>
                    router.push('/')
                }>
                Go back
            </button>
            
        </div>
    )
}